module.exports = __webpack_public_path__ + "static/img/diariobg.c3e159d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/CUIABA/diariobg.jpg
// module id = 1yyV
// module chunks = 1